import {LogManager} from "aurelia-framework";
export default LogManager.getLogger("app");
